import { fetchApi } from '@/config/axiosSetting';
import { IBodyDeleteSubstitutionPartParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/deleteBodySubstitutionPart/deleteBodySubstitutionPartQueryOption.type';

export const deleteBodySubstitutionPartQueryFunction = (
  params: IBodyDeleteSubstitutionPartParamsType,
) => {
  return fetchApi.delete(
    `body/reports/${params?.id}/adjusting/substitution_parts/`,
    {
      params,
    },
  );
};
